import { render, staticRenderFns } from "./cardex.vue?vue&type=template&id=8d241d3c&"
import script from "./cardex.vue?vue&type=script&lang=js&"
export * from "./cardex.vue?vue&type=script&lang=js&"
import style0 from "./cardex.vue?vue&type=style&index=0&id=8d241d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports